import moment from 'moment';
import store from '@/store/store';
import { calculTarif } from '@/services/calcul/calculTarif';
import formatDate from '@/services/general/formatIsoDate';
import CalculTlpeLc from '@/services/calcul/calculTlpeLc';
import { CalculTlpeJourAsync, CalculTlpeSemaineAsync } from '@/api/Materiel';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import { datesStringToPeriodes } from '@/services/devis/ajoutProduit/ajoutProduit';
import { getTarification } from '@/services/devis/ajoutProduit/ajoutProduitNumerique';
import { calculArrondi } from '@/services/general/arrondiCalcul';

export function reseauLcExtensionInitializer(reseauLc) {
  const reseauLcAvecExtension = reseauLc;
  let tarifDePose = reseauLc.tarifPose;
  let tarifBrut = reseauLc.tarifBrut;
  if (store.getters['user/site'] === 'alfa') {
    tarifDePose = 0;
    tarifBrut = reseauLc.tarifBrut + reseauLc.tarifPose;
  }
  reseauLcAvecExtension.extensionOpportunite = {
    commentaire: null,
    date: reseauLc.dateDebut,
    fraisTechnique: reseauLc.tarifImpression,
    duree: null,
    taxeMunicipale: reseauLc.tarifTlpe,
    tarifDePose,
    tarifBrut,
    tarifAnnuel: null,
    tarifNet: tarifBrut,
    tournante: false,
    instructionsAffichage: null,
    reseauPersoGuid: null,
    remise: 0,
    typeDeRemise: 0,
    masquerRemiseEdition: false,
  };
  return reseauLcAvecExtension;
}

export async function calculTlpePanneauLcInitializer(panneauLcAvecExtension) {
  const isAffixe2 = store.getters['parametrage/affixe2'];
  if (isAffixe2) {
    let dateFin = panneauLcAvecExtension.extensionOpportunite.dateFin;
    if (!dateFin) {
      dateFin = moment(panneauLcAvecExtension.extensionOpportunite.dateDisponibilite)
        .add(1, 'years').add(-1, 'days').toDate();
    }
    panneauLcAvecExtension.extensionOpportunite.taxeMunicipale =
      (await CalculTlpeJourAsync({
        produitId: panneauLcAvecExtension.extensionOpportunite.faceSelectionne.facNum,
        dateDebut: formatDate(panneauLcAvecExtension.extensionOpportunite.dateDisponibilite),
        dateFin: formatDate(dateFin),
        quantiteDispo: 1,
        surAnnee: true,
      })).data.result.montant;
  } else {
    panneauLcAvecExtension.extensionOpportunite.taxeMunicipale =
      await CalculTlpeLc(
        panneauLcAvecExtension.extensionOpportunite.faceSelectionne.facNum,
        panneauLcAvecExtension.extensionOpportunite.dateDisponibilite.getFullYear(),
      );
  }
}

export async function panneauLcExtensionInitializer(panneauLc, face, dateDebut, dateFin) {
  const panneauLcAvecExtension = panneauLc;
  let tarifDePose = panneauLc.tarifPose;
  let tarifAnnuel = panneauLc.tarifBrut;
  if (store.getters['user/site'] === 'alfa') {
    tarifDePose = 0;
    tarifAnnuel = panneauLc.tarifBrut + panneauLc.tarifPose;
  }
  let dateDebutTemp = new Date();
  if (dateDebut) dateDebutTemp = moment(dateDebut).toDate();
  let dateFinTemp = moment(dateDebutTemp).add(1, 'years').add(-1, 'days').toDate();
  if (dateFin) dateFinTemp = moment(dateFin).toDate();
  panneauLcAvecExtension.extensionOpportunite = {
    commentaire: null,
    date: dateDebut,
    fraisTechnique: null,
    duree: null,
    taxeMunicipale: null,
    tarifDePose,
    tarifAnnuel,
    faceSelectionne: face,
    faceSelectionneCode: face.facCode,
    reseauPersoGuid: null,
    urlPhoto: face.urlPhoto === '' ? panneauLc.urlPhoto : face.urlPhoto,
    remise: 0,
    typeDeRemise: 0,
    tarifNet: tarifAnnuel,
    dateDisponibilite: dateDebutTemp,
    dateFin: dateFinTemp,
  };
  await calculTlpePanneauLcInitializer(panneauLcAvecExtension);
  return panneauLcAvecExtension;
}

async function reseauTempoExtensionInitializerAffixe2(reseauTempo, semaine, annee) {
  const facesSouhaitees = reseauTempo.dataProposition.facesPrevues
    - reseauTempo.dataProposition.quantiteVendue;
  let tarifBaseBrut = reseauTempo.tarifBrut;
  let tarifNet = reseauTempo.tarifBrut;
  let tarifDePose = reseauTempo.tarifPose;
  const tarifTlpe = reseauTempo.tarifTlpe;
  const fraisTechnique = reseauTempo.tarifImpression;
  let tarifFaces = 0;
  if (!facesSouhaitees) {
    tarifBaseBrut = 0;
  }
  tarifFaces = tarifBaseBrut / facesSouhaitees;
  if (store.getters['user/site'] === 'alfa') {
    tarifDePose = 0;
    tarifBaseBrut = (reseauTempo.dataProposition.tarifBrut === null ? reseauTempo.tarifBrut
      : reseauTempo.dataProposition.tarifBrut) + (reseauTempo.dataProposition.tarifPose === null
      ? reseauTempo.tarifPose : reseauTempo.dataProposition.tarifPose);
  }
  const reseauTempoAvecExtension = reseauTempo;
  if (reseauTempo.tarifUnitaire) {
    tarifFaces = tarifBaseBrut;
    tarifNet = facesSouhaitees * tarifBaseBrut;
  }
  reseauTempoAvecExtension.extensionOpportunite = {
    semaine: semaine,
    annee: annee,
    facesPrevues: reseauTempo.dataProposition.facesPrevues,
    jourDepart: reseauTempo.jourDepart,
    commentaire: null,
    facesSouhaitees: facesSouhaitees,
    tarifBaseBrut,
    tarifBaseTaxes: tarifTlpe,
    tarifBaseFaces: tarifFaces,
    tarifImpression: fraisTechnique,
    tarifDePose,
    tarifNet: tarifNet,
    faces: [],
    reseauPersoGuid: null,
    remise: 0,
    typeDeRemise: 0,
    masquerRemiseEdition: false,
  };
  if (reseauTempo.calculAutoTlpe) {
    reseauTempoAvecExtension.extensionOpportunite.tarifBaseTaxes =
      (await CalculTlpeSemaineAsync({
        produitId: reseauTempoAvecExtension.num,
        anneeSemaine: parseInt(getAnneeSemaine(annee, semaine), 10),
        produitsFacesSelectionnes: [],
        quantiteSouhaitee: facesSouhaitees,
      })).data.result.montant;
  }
  if (!reseauTempo.tarifUnitaire) {
    calculTarif(reseauTempoAvecExtension.extensionOpportunite);
  } else {
    reseauTempoAvecExtension.extensionOpportunite.tarifImpression = reseauTempo
      .tarifImpression * facesSouhaitees;
    reseauTempoAvecExtension.extensionOpportunite.tarifHT = tarifNet;
    reseauTempoAvecExtension.extensionOpportunite
      .tarifDePose = reseauTempo.tarifPose * facesSouhaitees;
    reseauTempoAvecExtension.extensionOpportunite
      .taxeMunicipale = reseauTempo.tarifTlpe * facesSouhaitees;
  }
  return reseauTempoAvecExtension;
}

export async function reseauTempoExtensionInitializer(reseauTempo, semaine, annee) {
  if (!reseauTempo.dataProposition) {
    return reseauTempo;
  }
  const isAffixe2 = store.getters['parametrage/affixe2'];
  if (isAffixe2) {
    return reseauTempoExtensionInitializerAffixe2(reseauTempo, semaine, annee);
  }

  let facesSouhaitees = (reseauTempo.dataProposition.facesPrevues -
    reseauTempo.dataProposition.quantiteVendue);
  if (facesSouhaitees < 0) {
    facesSouhaitees = 0;
  }
  let tarifFaces = 0;
  if (reseauTempo.dataProposition.facesPrevues > 0) {
    tarifFaces = reseauTempo.dataProposition.tarifBrut /
    reseauTempo.dataProposition.facesPrevues;
  }
  let tarifDePose = reseauTempo.dataProposition.tarifPose === null
    ? reseauTempo.tarifPose : reseauTempo.dataProposition.tarifPose;
  let tarifBaseBrut = (reseauTempo.dataProposition.tarifBrut === null ? reseauTempo.tarifBrut
    : reseauTempo.dataProposition.tarifBrut);
  if (store.getters['user/site'] === 'alfa') {
    tarifDePose = 0;
    tarifBaseBrut = (reseauTempo.dataProposition.tarifBrut === null ? reseauTempo.tarifBrut
      : reseauTempo.dataProposition.tarifBrut) + (reseauTempo.dataProposition.tarifPose === null
      ? reseauTempo.tarifPose : reseauTempo.dataProposition.tarifPose);
  }
  const reseauTempoAvecExtension = reseauTempo;
  reseauTempoAvecExtension.extensionOpportunite = {
    semaine: semaine,
    annee: annee,
    facesPrevues: reseauTempo.dataProposition.facesPrevues,
    jourDepart: reseauTempo.jourDepart,
    commentaire: null,
    tarifImpression: null,
    facesSouhaitees: facesSouhaitees,
    tarifBaseTaxes: (reseauTempo.dataProposition.tarifTaxes === null ? reseauTempo.tarifTlpe
      : reseauTempo.dataProposition.tarifTaxes),
    tarifDePose,
    tarifBaseBrut,
    tarifBaseFaces: tarifFaces,
    tarifNet: null,
    faces: [],
    reseauPersoGuid: null,
    remise: 0,
    typeDeRemise: 0,
    masquerRemiseEdition: false,
  };
  if (isAffixe2) {
    if (reseauTempo.calculAutoTlpe) {
      reseauTempoAvecExtension.extensionOpportunite.tarifBaseTaxes =
        (await CalculTlpeSemaineAsync({
          produitId: reseauTempoAvecExtension.num,
          anneeSemaine: parseInt(getAnneeSemaine(annee, semaine), 10),
          produitsFacesSelectionnes: [],
          quantiteSouhaitee: facesSouhaitees,
        })).data.result.montant;
    } else {
      reseauTempoAvecExtension.extensionOpportunite.tarifBaseTaxes = reseauTempo.tarifTlpe;
    }
  }
  calculTarif(reseauTempoAvecExtension.extensionOpportunite);
  return reseauTempoAvecExtension;
}

export async function panneauNumeriqueExtensionInitializer(
  panneauNumerique, typeTarification, periode) {
  const periodes = datesStringToPeriodes(periode);
  const maPeriode = periodes[0];
  let monTypeDeTarif = typeTarification;
  let qte = moment(maPeriode.fin, 'DD/MM/YYYY').add(1, 'd').diff(moment(maPeriode.debut, 'DD/MM/YYYY'), 'w', true);
  if (qte >= 4) {
    // passage tarification mois
    qte = moment(maPeriode.fin, 'DD/MM/YYYY').add(1, 'd').diff(moment(maPeriode.debut, 'DD/MM/YYYY'), 'M', true);
    monTypeDeTarif = 102;
    if (qte > 11) {
      // passage tarification année
      qte = moment(maPeriode.fin, 'DD/MM/YYYY').add(1, 'd').diff(moment(maPeriode.debut, 'DD/MM/YYYY'), 'y', true);
      monTypeDeTarif = 103;
    } else if (qte >= 3) {
      // passage tarification mois
      monTypeDeTarif = 104;
    }
  }
  const panneauNumeriqueAvecExtension = panneauNumerique;
  panneauNumeriqueAvecExtension.extensionOpportunite = {
    commentaire: null,
    typeTarification: monTypeDeTarif,
    quantite: calculArrondi(qte, 5),
    spotsPub: null,
    taxeMunicipale: null,
    fraisAdserving: null,
    tarifHt: null,
    periodeModifieManuellement: false,
    periode: ` ${periode} `,
    reseauPersoGuid: null,
    nbDiffusion: null,
    remise: 0,
    typeDeRemise: 0,
  };
  const tarif = await getTarification(panneauNumeriqueAvecExtension, moment(maPeriode.debut, 'DD/MM/YYYY'));

  if (tarif !== null && tarif !== undefined) {
    panneauNumeriqueAvecExtension.extensionOpportunite.tarifHt = parseFloat(tarif.prixUnitaire);
    panneauNumeriqueAvecExtension.extensionOpportunite.taxeMunicipale = parseFloat(tarif.liaisonsTarif.find(el => el.libelle.includes('Tlpe')).prixUnitaire);
    panneauNumeriqueAvecExtension.extensionOpportunite.fraisAdserving = parseFloat(tarif.liaisonsTarif.find(el => el.libelle.includes('Frais')).prixUnitaire);
  }
  return panneauNumeriqueAvecExtension;
}

export function reseauNumeriqueExtensionInitializer(reseauNumerique, typeTarification, periode) {
  const reseauNumeriqueAvecExtension = reseauNumerique;
  reseauNumeriqueAvecExtension.extensionOpportunite = {
    commentaire: null,
    typeTarification: typeTarification,
    quantite: 1,
    spotsPub: null,
    taxeMunicipale: null,
    fraisAdserving: null,
    tarifHt: null,
    tarifNet: null,
    periodeModifieManuellement: false,
    periode: ` ${periode} `,
    reseauPersoGuid: null,
    nbDiffusion: null,
    remise: 0,
    typeDeRemise: 0,
  };
  return reseauNumeriqueAvecExtension;
}



// WEBPACK FOOTER //
// ./src/services/panier/extensionInitializer.js